import { createReducer, on } from '@ngrx/store';
import { PaymentState } from './payment.state';
import {
  clearPaymentSession, clearState, clearTokenResponse, closeErrorAlert, closeSuccessAlert, creditCardTokenSuccess,
  invokeInvoiceResponse,
  invokePayment,
  invokePaymentSession, paymentFailure, paymentSuccess, setCreditCardTokenResponse, setInvoiceResponse
  , setPaymentRequest, setPaymentSession, setPaymentToken, startCreditCardLoading, startPaymentLoading, stopCreditCardLoading
} from './payment.action';

export const initialState: PaymentState = {
  paymentSession: {
    sessionToken: null,
    merchantId: '',
    merchantSiteId: ''
  },
  patientCreditCardToken: '',
  paymentResponse: {
    authCode: '',
    transactionId: '',
    requestStatus: '',
    transactionStatus: '',
    internalRequestId: null,
    orderId: '',
    userTokenId: '',
    clientRequestId: '',
    clientUniqueId: '',
    sessionToken: '',
    merchantId: '',
    merchantSiteId: '',
    patientId: 0,
    patientTreatmentContractId: 0,
    patientTreatmentPaymentPlanId: 0,
    patientTreatmentInstallmentPlanId: 0,
    transactionAmount: 0,
    paymentMethod: '',
    patientFinancialResponsiblePersonId: 0,
    userPaymentOptionId: '',
    ccTempToken: '',
    cvv: '',
    errorReason: '',
    ledgerName: '',
    transactionSubCategoryEnum: 0,
    patients: []
  },
  paymentStateEvents: {
    errorMessage: '',
    showErrorAlert: false,
    loading: false,
    showSuccessAlert: false,
    showSuccessToast: false,
    successToastMessage: '',
    showTokenErrorAlert: false,
    creditCardLoading: false,
    sessionLoading: false
  },
  creditCardTokenResponse: {
    internalRequestId: 0,
    status: '',
    errCode: 0,
    reason: '',
    version: '',
    sessionToken: '',
    ccTempToken: '',
    isVerified: false,
    uniqueCC: '',
    cardType: '',
    issuerCountry: '',
    error: null
  },
  paymentRequest: {
    encodedString: '',
    transactionAmount: '',
    ccTempToken: ''
  },
  invoiceResponse: {
    patientName: '',
    dueAmount: 0,
    practiceId: 0,
    practiceGuid: '',
    patientPrimaryEmailAddress: '',
    patientPrimaryPhone: '',
    practiceName: ''
  },
  paymentToken: ''
};

export const paymentReducer = createReducer(
  initialState,
  on(setPaymentSession, (state, { paymentSession }) => {
    return {
      ...state,
      paymentSession: paymentSession,
      paymentStateEvents: {
        ...state.paymentStateEvents,
        sessionLoading: false
      }
    };
  }),
  on(creditCardTokenSuccess, (state, { patientCreditCardToken }) => ({
    ...state,
    patientCreditCardToken: patientCreditCardToken
  })),
  on(setCreditCardTokenResponse, (state, { result }) => ({
    ...state,
    creditCardTokenResponse: result
  })),
  on(closeErrorAlert, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      showTokenErrorAlert: false,
      showErrorAlert: false,
      errorMessage: ''
    }
  })),
  on(closeSuccessAlert, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      showSuccessAlert: false,
      successToastMessage: "",
      errorMessage: ''
    }
  })),
  on(paymentSuccess, (state, { paymentResponse }) => ({
    ...state,
    paymentResponse: paymentResponse,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      showErrorAlert: false,
      showSuccessAlert: false,
      loading: false
    }
  })),
  on(paymentFailure, (state, { errorMessage }) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      loading: false,
      showErrorAlert: true,
      errorMessage: errorMessage,
    }
  })),
  on(startCreditCardLoading, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      creditCardLoading: true
    }
  })),
  on(stopCreditCardLoading, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      creditCardLoading: false
    }
  })),
  on(startPaymentLoading, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      loading: true
    }
  })),
  on(invokePaymentSession, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      sessionLoading: true
    }
  })),
  on(setPaymentRequest, (state, { paymentRequestModel }) => ({
    ...state,
    paymentRequest: paymentRequestModel
  })),
  on(clearPaymentSession, (state) => ({
    ...state,
    paymentSession: initialState.paymentSession
  })),

  on(clearTokenResponse, (state) => ({
    ...state,
    creditCardTokenResponse: initialState.creditCardTokenResponse
  })),
  on(setInvoiceResponse, (state, { invoiceResponse }) => ({
    ...state,
    invoiceResponse: invoiceResponse,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      loading: false
    }
  })),
  on(invokeInvoiceResponse, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      loading: true
    }
  })),
  on(setInvoiceResponse, (state, { invoiceResponse }) => ({
    ...state,
    invoiceResponse: invoiceResponse
  })),

  on(invokePayment, (state) => ({
    ...state,
    paymentStateEvents: {
      ...state.paymentStateEvents,
      loading: true
    }
  })),
  on(setPaymentToken, (state, { encodedString }) => ({
    ...state,
     paymentToken: encodedString
  })),

  on(clearState, () => initialState),

);